import {DecimalPipe} from '@angular/common'
import {Component, computed, input} from '@angular/core'
import {MatCheckbox} from '@angular/material/checkbox'
import {COLOR_LIST} from '../../../application/data-types'
import {KalpLoan} from '../../../model/kalp-loan'

@Component({
  selector: 'spb-loan-table',
  templateUrl: './loan-table.component.html',
  styleUrls: ['./loan-table.component.scss'],
  imports: [MatCheckbox, DecimalPipe]
})
export class LoanTableComponent {

  public readonly loans = input<KalpLoan[]>([])

  public readonly loanCost = input<[number, number, number]>([0, 0, 0])

  public readonly scenarioChange = input(false)

  public colorList = COLOR_LIST

  // Sort by position based on 'expires' then 'terms' (must be same order in both the loans table and the timeline)
  public readonly sortedLoans = computed(() => {
    return [...this.loans()].toSorted((a, b) =>
      a.expires - b.expires || a.terms - b.terms
    )
  })
}
